import http from './index'

export function getOtpList(group) {
  const params = {}
  if (group) params.group = group
  return http.get('/otp/list', { params })
}

export function createOtp(data) {
  return http.post('/otp/create', data)
}

export function updateOtp(id, data) {
  return http.put(`/otp/update/${id}`, data)
}

export function deleteOtp(id) {
  return http.delete(`/otp/delete/${id}`)
}

// --- Group APIs ---
export function getGroupList() {
  return http.get('/group/list')
}

export function createGroup(data) {
  return http.post('/group/create', data)
}

export function updateGroup(id, data) {
  return http.put(`/group/update/${id}`, data)
}

export function deleteGroup(id, data) {
  return http.delete(`/group/delete/${id}`, { data })
}
